import { Box } from '@mui/material';
import { FC } from 'react';
import 'react-before-after-slider-component/dist/build.css';
import ReactCompareImage from 'react-compare-image';
import {CustomIcon} from "../../../shared/assets/icons";
import exampleSrc from '../../../shared/assets/img/example-src.jpg';
import exampleArt from '../../../shared/assets/img/example-art.jpg';

export const HomeCompareImage: FC = () => {
  return (
    <Box sx={{
      width: {xl: '450px', lg:'350px', xs: '250px'},
      touchAction: 'none',
    }} >
      <ReactCompareImage
        aspectRatio="wider"
        leftImage={exampleArt}
        rightImage={exampleSrc}
        handle={
          <Box
            sx={{
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              backgroundColor: 'transparent',
              border: '1px solid white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',

              '&:hover': {
                cursor: 'pointer',
              },
            }}
          >
            <Box
              sx={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                backgroundColor: 'white',
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'center',
              }}
            >
              <CustomIcon name={"hand"}/>
            </Box>
          </Box>
        }
      />
</Box>
  );
};
